import * as angular from 'angular';
import * as _ from 'lodash';

import { serviceModule } from '../services/services.module';

import * as d from './index';

export const componentModule = 'wt-directive';
const m = angular.module(componentModule, [serviceModule]);
export default m.name;

for (const key of Object.keys(d)) {
    if (d[key].hasOwnProperty('directiveId')) {
        const obj = d[key];
        m.directive(obj.directiveId, () => obj);
    }
}